module.exports = __webpack_public_path__ + "media/birthday.660350a3.mp4";